<template>
  <div
    class="item-box-content puclib_lingheight"
    style="padding:20px 20px;"
    :style="{'paddingBottom':paddingTop && ishowTitle?'30px':'20px','paddingTop':tabsdata.length ? '9px': '20px'}"
  >
    <div v-if="ishowTitle && tabsdata.length === 0">
      <span class="bold"></span><span class="basic">{{title}}</span></div>
    <div v-if="ishowTitle && tabsdata.length !== 0">
      <span
        class="bold"
        style="vertical-align: middle"></span>
      <el-tabs
        v-model="activeTabName"
        @tab-click="handleClick"
        style="display: inline-block;vertical-align: middle;margin-left: 20px;">
        <el-tab-pane v-for="(item,index) in tabsdata" :key="index" :label="item.label" :name="item.name"></el-tab-pane>
      </el-tabs>
    </div>
    <div :style="{'paddingTop':paddingTop && ishowTitle?'20px':'0px','paddingLeft':isTable || !ishowTitle?'0' :'20px'}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkModule',
  data () {
    return {
      activeTabName: this.activeName
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    paddingTop: {
      type: Boolean,
      default: true
    },
    tabsdata: {
      type: Array,
      default: () => {
        return []
      }
    },
    activeName: {
      type: String,
      default: ''
    },
    ishowTitle: {
      type: Boolean,
      default: true
    },
    isTable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick () {
      this.$emit('tabclick', this.activeTabName)
    }
  }
}
</script>

<style scoped lang="less">
  .item-box-content {
    position: relative;
  }

  /deep/ .el-tabs__header {
    margin: 0 !important;
  }

  /deep/ .el-tabs__content {
    display: none;
  }

  /deep/ .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
  }

  .bold {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .basic {
    padding-left: 20px;
  }
</style>
<style>
  .puclib_lingheight .el-col.el-col-8 {
    line-height: 14px !important;
  }
</style>
